module.exports = __webpack_public_path__ + "static/media/polysarcus_denticauda.ca66f83e.jpg";